export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-orange-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block border border-gray-300 px-4 py-1.5 rounded-full mb-6">
              <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">Who We Are</span>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold mb-4">
              <span className="text-gray-900">Your Local Heating</span>
              <br />
              <span className="text-gray-500 font-light">& Cooling Pros</span>
            </h2>

            <div className="flex items-center space-x-8 my-12">
              <div>
                <div className="text-5xl font-bold text-gray-900">5.0★</div>
                <div className="text-sm text-gray-600 mt-1">Google Rating</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-gray-900">500+</div>
                <div className="text-sm text-gray-600 mt-1">Happy Customers</div>
              </div>
            </div>

            <p className="text-base text-gray-700 leading-relaxed mb-8">
              Trio HVACR Services is your trusted HVAC expert in Baltimore, MD, specializing in AC repair, boiler repair, HVAC service, and installation. We provide reliable solutions for central heating and air systems, forced air heat, and full-service residential and commercial HVAC needs.
            </p>

            <p className="text-base text-gray-700 leading-relaxed mb-8">
              Count on our skilled technicians for fast, affordable, and professional service year-round. Stay comfortable with Trio—your local heating and cooling pros.
            </p>

            <a href="#contact" className="inline-block text-gray-900 font-medium underline hover:text-orange-600 transition-colors cursor-pointer">
              Learn Our Story →
            </a>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="https://public.readdy.ai/ai/img_res/ad5d85bf1feb03722d9df02d82d064a4.jpg"
                    alt="HVAC Equipment"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative h-48 rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20in%20uniform%20working%20with%20precision%20tools%20on%20heating%20system%2C%20focused%20and%20skilled%2C%20clean%20professional%20environment%2C%20simple%20background%20emphasizing%20expertise%20and%20quality%20workmanship&width=400&height=400&seq=about-img-002&orientation=squarish"
                    alt="Professional Service"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-12">
                <div className="relative h-48 rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Satisfied%20homeowner%20smiling%20with%20HVAC%20technician%20in%20comfortable%20home%20interior%2C%20happy%20customer%20experience%2C%20warm%20welcoming%20atmosphere%2C%20simple%20clean%20background%20showing%20customer%20satisfaction%20and%20trust&width=400&height=400&seq=about-img-003&orientation=squarish"
                    alt="Happy Customer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20modern%20residential%20HVAC%20system%20installation%20with%20efficient%20air%20conditioning%20unit%2C%20professional%20setup%20in%20home%20environment%2C%20simple%20background%20emphasizing%20modern%20comfort%20and%20energy%20efficiency&width=400&height=500&seq=about-img-004&orientation=portrait"
                    alt="Modern HVAC System"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
